import React, {useEffect} from "react";
import {useKeycloak} from "@react-keycloak/web";
import authDataStorage from "../auth/auth-data-provider/context/auth-data-storage";

const {fetchLocale, storeLocaleLoadBoolean} = authDataStorage;


const AutoLoginComponent = ({children}) => {
    const {keycloak, initialized} = useKeycloak();
    const locale = fetchLocale();

    useEffect(() => {
        if (initialized && !!keycloak && !keycloak.authenticated) {
            storeLocaleLoadBoolean(false);
            keycloak.login({locale: locale});
        }
    }, [initialized, keycloak])

    return (children);
};

export default AutoLoginComponent;
